import axios from 'axios'
import env from '../env'

const { BRANDID } = Config

export default class PermissionApi {
  /** 检查品牌级别的权限是否过期 */
  static checkBrandPermissionByKey (data: any) {
    return axios.post(`${env.SIGNJALLIANCESERVICE}/checkBrandPermissionByKeyV2`, data).catch((err) => {
      return err
    })
  }
}
